<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    import Profile from "./helpers/profile";

    export default {
        mounted() {
            Profile.setData({language: this.$ml.current});
        },
    }
</script>

<style lang="scss">
  @import "../public/static/fonts/fonts.css";

  html body {
    font-family: NovaPoshta, Avenir, Helvetica, Arial, sans-serif;
  }
  #app {
    font-family: NovaPoshta, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow: auto;
    height: 100%;
    overscroll-behavior: contain;
    input {
      font-family: NovaPoshta, Avenir, Helvetica, Arial, sans-serif;
    }
  }


  .demo-width-class {
    width: 400px;
  }

  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    min-height: 0!important;
    height: 100%;
    overscroll-behavior: contain;
  }

  input {
      padding: 0;
      box-shadow: none;
      -webkit-appearance: none;
  }
  .grow {
    flex-grow: 1;
  }
  .helpText {
    display: none;
  }
  .bottom {
      margin-bottom: 32px;
      margin-top: 32px;
  }

  .bottom, .bottomLink {
      .left {
          width: 40%;
          float: left;
      }
      .right {
          width: 56%;
          float: right;
      }
  }

  .link {
    cursor: pointer;
    color: #5CD69B;
    margin-top: -4px;
    text-decoration: none;
    &:hover,
    &:focus {
      text-decoration: underline;
      outline: none;
    }
  }

  .wrap {
    /*padding: 66px 32px 32px;*/
    /*padding: 66px 9% 32px;*/
    padding: 50px 9% 0;
    box-sizing: border-box;
  }
  .textfieldScreen_content {
    max-width: 700px;
  }
  .bottom {

    .left {
      width: 40%;
      float: left;
    }
    .right {
      width: 56%;
      float: right;
    }
  }

  .bottomLink {
      margin-bottom: 4px;
  }
  @media (max-width: 320px) {
    h1 {
      line-height: 1.1em;
    }
    h2, .h2 {
      text-align: left;
      margin: 0;
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
    }
    .leftContent {
      display: none;
    }
    .rightContent {
      position: relative;
      float: none;
      width: 100%;
      .headBlock {
        display: block;
      }
    }
  }
  @media (min-width: 321px) and (max-width: 600px) {
    h1 {
      font-weight: 700;
      font-size: 36px;
      line-height: 43px;
      margin: 0;
    }
    h2, .h2 {
        margin: -1em 0 0 0;
      text-align: left;
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
    }
    p, a {
      text-align: left;
      font-weight: 300;
      font-size: 16px;
      line-height: 22px;
    }
    .leftContent {
      display: none;
    }
    .rightContent {
      position: relative;
      float: none;
      width: 100%;
      .headBlock {
        display: block;
      }
    }

  }
  @media (min-width: 601px) and (max-width: 750px) {
    h1 {
      font-weight: 700;
      font-size: 36px;
      line-height: 43px;
      margin: 0;
    }
    h2, .h2 {
      text-align: left;
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
      margin: 0;
    }
    p, a {
      text-align: left;
      font-weight: 300;
      font-size: 16px;
      line-height: 22px;
    }
    .leftContent {
      display: block;
      position: relative;
      float: left;
      width: 50%;
    }
    .rightContent {

      display: block;
      position: relative;
      float: right;
      width: 50%;
      /*padding: 200px 113px 0;*/
      /*padding: 10% 6% 0;*/
      padding: 100px 5% 0;
      box-sizing: border-box;
      .headBlock {
        display: none;
      }
      .helpText {
        display: block;
        margin-top: 34px;
        color: #434343;
        text-align: left;
        font-weight: 300;
        font-size: 18px;
        line-height: 24px;
        a {
          display: inline-block;
          margin-top: 12px;
          color: #5CD69B;
        }
      }
    }
  }
  @media (min-width: 751px) {
    h1 {
      font-size: 44px;
      line-height: 53px;
      font-weight: 700;
      margin: 0;
    }
    h2, .h2 {
      text-align: left;
      font-size: 28px;
      line-height: 34px;
      font-weight: 700;
      margin: 0;
    }
    p {
      font-size: 18px;
      line-height: 26px;
      font-weight: 300;
    }

    .leftContent {
      display: block;
      position: relative;
      float: left;
      width: 50%;
    }
    .rightContent {

      display: block;
      position: relative;
      float: right;
      width: 50%;
      /*padding: 200px 113px 0;*/
      /*padding: 10% 6% 0;*/
      padding: 100px 5% 0;
      box-sizing: border-box;
      .headBlock {
        display: none;
      }
      .helpText {
        display: block;
        margin-top: 34px;
        color: #434343;
        text-align: left;
        font-weight: 300;
        font-size: 18px;
        line-height: 24px;
        a {
          display: inline-block;
          margin-top: 12px;
          color: #5CD69B;
        }
      }
    }
  }


  /*@media (max-width: 320px) {*/
  /*}*/
  /*@media (min-width: 321px) and (max-width: 600px) {*/
  /*}*/
  /*@media (min-width: 601px) and (max-width: 750px) {*/
  /*}*/
  /*@media (min-width: 751px) {*/
  /*}*/


</style>
